
import ql from './ql/ql';
// 导出一个map
export default {
  ql
};
